<div
  class="credits"
  [matTooltipDisabled]="showName"
  matTooltip="{{ credits ?? 0 }} {{
    handlePluralTranslation(credits ?? 0, 'creditName') | translate
  }}"
>
  <span class="credits__logo"></span>
  <span class="credits__amount"
    >{{ credits ?? 0 }}
    <span *ngIf="showName">
      {{ handlePluralTranslation(credits ?? 0, "creditName") | translate }}
    </span>
  </span>
</div>
